import {
  CIVILBUDGETDETAIL_LOADING,
  GET_CIVILBUDGETDETAIL,
  GET_CIVILBUDGETDETAIL_SUCCESS,
  GET_CIVILBUDGETDETAIL_FAIL,
  ADD_CIVILBUDGETDETAIL_SUCCESS,
  ADD_CIVILBUDGETDETAIL_FAIL,
  DELETE_CIVILBUDGETDETAIL_SUCCESS,
  DELETE_CIVILBUDGETDETAIL_FAIL,
  UPDATE_CIVILBUDGETDETAIL_SUCCESS,
  UPDATE_CIVILBUDGETDETAIL_FAIL,
  CIVILBUDGETDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  civilBudgetDetails: [],
  error: {},
};

const CivilBudgetDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILBUDGETDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETDETAIL:
          return {
            ...state,
            civilBudgetDetails: action.payload.data,
            isCivilBudgetDetailCreated: false,
            isCivilBudgetDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILBUDGETDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilBudgetDetailCreated: false,
            isCivilBudgetDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILBUDGETDETAIL: {
      return {
        ...state,
        isCivilBudgetDetailCreated: false,
        loading: true,
      };
    }

    case CIVILBUDGETDETAIL_LOADING: {
      return {
        ...state,
        isCivilBudgetDetailCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILBUDGETDETAIL_SUCCESS:
      return {
        ...state,
        isCivilBudgetDetailCreated: true,
        loading: false,
        civilBudgetDetails: [action.payload.data, ...state.civilBudgetDetails],
      };

    case ADD_CIVILBUDGETDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILBUDGETDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgetDetails: state.civilBudgetDetails.filter(
          civilCivilBudgetDetail => civilCivilBudgetDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILBUDGETDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILBUDGETDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgetDetails: state.civilBudgetDetails.map(civilCivilBudgetDetail =>
          civilCivilBudgetDetail.id.toString() === action.payload.data.id.toString() ? { ...civilCivilBudgetDetail, ...action.payload.data } : civilCivilBudgetDetail
        ),
      };

    case UPDATE_CIVILBUDGETDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILBUDGETDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilBudgetDetail;